import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    chart_value: [8, 2, 5, 9, 5, 11, 3, 5, 10, 0, 1, 8, 2, 9, 0, 13, 10, 7, 16],
    ch_value: 10,
    temp1_chart_value: [8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8],
    temp1_value: 8,

    recipearray: [],

    selectedrecipe: {
      name: 'default name',
      grainweight: 0,
      mashwatervol: 0,
      striketemp: 0,
      flowrate: 0,
      mashstages: [],
      spargewatervol: 0,
      spargetemp: 0,
      boiltime: 0,
      adjuncts: [],
      cooltemp: 0,
      notes: ''
    },

    name: 'default',
    recipeJSON: ''


  },
  mutations: {
    update_chart_value (state, new_value) {
      state.chart_value.push(new_value);
      state.chart_value.shift();
      state.ch_value = new_value;
    },   
    update_temp1 (state, newTemp) {
      state.temp1_chart_value.push(newTemp)
      state.temp1_chart_value.shift()
      state.temp1_value = newTemp;
    },
    set_recipe_array (state, recipe) {
      state.recipearray = recipe
    },
    set_recipe (state, recipe) {
      // do some shit with JSON array string etc?
      // needs recipe.recipe not just recipe.
      state.selectedrecipe.name = recipe.recipe.name
      state.selectedrecipe.grainweight = recipe.recipe.grainweight
      state.selectedrecipe.mashwatervol = recipe.recipe.mashwatervol
      state.selectedrecipe.striketemp = recipe.recipe.striketemp
      state.selectedrecipe.mashstages = recipe.recipe.mashstages
      state.selectedrecipe.flowrate = recipe.recipe.flowrate
      state.selectedrecipe.spargewatervol = recipe.recipe.spargewatervol
      state.selectedrecipe.spargetemp = recipe.recipe.spargetemp
      state.selectedrecipe.boiltime = recipe.recipe.boiltime
      state.selectedrecipe.adjuncts = recipe.recipe.adjuncts
      state.selectedrecipe.cooltemp = recipe.recipe.cooltemp
      state.selectedrecipe.notes = recipe.recipe.notes
    },
    set_recipe_JSON (state, recipeJSON) {
      state.recipeJSON = recipeJSON
      
    }

  },
  actions: {
    update_chart_value({ commit }) {
      axios.get("/api/v1/temp/raw")
        .then(data => {
          commit("update_chart_value", data.data.raw);
        })
        .catch(error => {
          console.log(error);
        });
    },
    update_temp1({ commit }) {
      axios.get("/api/v1/manual/raw")
        .then(data => {
          commit("update_temp1", data.data.raw);
        })
        .catch(error => {
          console.log(error);
        });
    },
    update_brewery_setup({ commit }) {
      axios.get("/api/v1/setup/load")
        .then(data => {
          commit("update_chart_value", data.data.raw);
        })
        .catch(error => {
          console.log(error);
        });
    },
  }
})
